const PASSWORD_SPECIAL_CHARS =
  /[!@#$%^&*(),.?":{}|<>_+\-=[\]\\;'~/`]/;
const PASSWORD_VALID_CHARS =
  /^[A-Za-z\d!@#$%^&*(),.?":{}|<>_+\-=[\]\\;'~/`]+$/;

export function validatePasswordStrength(password: string): string {
  if (!password.trim()) {
    return 'Password is required';
  }

  if (password.length < 8) {
    return 'Password must be at least 8 characters long';
  }

  if (!/[a-z]/.test(password)) {
    return 'Password must contain at least one lowercase letter';
  }

  if (!/[A-Z]/.test(password)) {
    return 'Password must contain at least one uppercase letter';
  }

  if (!/\d/.test(password)) {
    return 'Password must contain at least one number';
  }

  if (!PASSWORD_SPECIAL_CHARS.test(password)) {
    return 'Password must contain at least one special character (!@#$%^&*(),.?":{}|<>_+-=[]\\;\'~/`)';
  }

  if (!PASSWORD_VALID_CHARS.test(password)) {
    return 'Password can only contain letters, numbers, and special characters (!@#$%^&*(),.?":{}|<>_+-=[]\\;\'~/`)';
  }

  return '';
}

export function extractPasswordValidationError(error: any): string {
  const details = error?.response?.data?.detail;

  if (Array.isArray(details)) {
    const passwordError = details.find((item: any) => {
      const path = Array.isArray(item?.loc) ? item.loc : [];
      return path.includes('password') || path.includes('new_password');
    });

    if (passwordError?.msg) {
      return passwordError.msg;
    }
  }

  return '';
}
